module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-4-6.1d8791b0.png";